
export default {
  name: 'UISlider',
  model: { prop: 'value', event: 'input' },

  props: {
    value: { type: Number, required: true },

    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    step: { type: Number, default: 1 },
    disabled: { type: Boolean, default: false },

    trackClass: {
      type: String,
      default: 'h-2 bg-neutral-4',
    },
    activeTrackClass: {
      type: String,
      default: 'bg-primary',
    },
    thumbClass: {
      type: String,
      default: 'h-6 w-6 rounded-full bg-primary border-4 border-neutral-4',
    },
  },

  data() {
    return {
      internalValue: this.clamp(this.value),
      isDragging: false,
    };
  },

  computed: {
    ratio() {
      const range = this.max - this.min;
      if (range <= 0) return 0;
      return (this.internalValue - this.min) / range;
    },
  },

  watch: {
    value(next) {
      const v = this.clamp(next);
      if (v !== this.internalValue) this.internalValue = v;
    },
  },

  mounted() {
    window.addEventListener('mouseup', this.handlePointerUp);
    window.addEventListener('touchend', this.handlePointerUp, {
      passive: true,
    });
    window.addEventListener('touchcancel', this.handlePointerUp, {
      passive: true,
    });
  },

  beforeDestroy() {
    window.removeEventListener('mouseup', this.handlePointerUp);
    window.removeEventListener('touchend', this.handlePointerUp);
    window.removeEventListener('touchcancel', this.handlePointerUp);
  },

  methods: {
    clamp(v) {
      const n = Number(v);
      if (Number.isNaN(n)) return this.min;
      return Math.min(this.max, Math.max(this.min, n));
    },

    handleInput(e) {
      const v = this.clamp(e.target.value);
      this.internalValue = v;

      // v-model support
      this.$emit('input', v);

      // onChange (every tick)
      this.$emit('onChange', v);
    },
    handlePointerUp() {
      if (!this.isDragging) return;
      this.isDragging = false;

      // onSlideEnd (release)
      this.$emit('onSlideEnd', this.internalValue);
    },
  },
};
